<template>
  <div>
    <h4 v-if="hideOnDashboard">Overview</h4>
    <b-row class="pt-5">
      <slot name="total-agents"></slot>
      <b-col>
        <b-card class="rc-card">
          <div class="grey-circle" v-if="!hideOnDashboard">
            <img src="./../assets/icons/pinpad.svg" alt="" />
          </div>
          <slot name="card-1-title"></slot>
          <slot name="card-1-val"></slot>
          <p class="fs-overview">
            <slot name="card-1-percent"></slot>
            <slot name="from"></slot>
          </p>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="rc-card">
          <div class="grey-circle" v-if="!hideOnDashboard">
            <img src="./../assets/icons/pos.svg" alt="" />
          </div>
          <slot name="card-2-title"></slot>
          <slot name="card-2-val"></slot>
          <p class="fs-overview">
            <slot name="card-2-percent"></slot>
            <slot name="from"></slot>
          </p>
        </b-card>
      </b-col>
      <b-col v-if="!hideOnDashboard">
        <b-card class="rc-card">
          <div class="grey-circle" v-if="!hideOnDashboard">
            <img src="./../assets/icons/bank-transfer.svg" alt="" />
          </div>
          <slot name="card-3-title"></slot>
          <slot name="card-3-val"></slot>
          <p class="fs-overview">
            <slot name="card-3-percent"></slot>
            <slot name="from"></slot>
          </p>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="rc-card">
          <div class="grey-circle" v-if="!hideOnDashboard">
            <img src="./../assets/icons/accounts.svg" alt="" />
          </div>
          <slot name="card-4-earnings"></slot>
          <slot name="card-4-val"></slot>
          <p class="fs-overview">
            <slot name="card-4-percent"></slot>
            <slot v-if="!hideOnDashboard"> from last month</slot>
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Overview",
  data() {
    return {
      hideOnDashboard: true,
    };
  },
  mounted() {
    this.hideOnDashboard = this.$router.history.current.path !== "/dashboard";
  },
};
</script>

<style>
.grey-circle {
  width: 3rem;
  height: 3rem;
  background-color: rgba(238, 47, 82, 0.05);
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.grey-color {
  color: var(--gray-400);
}
.pl_4 {
  padding-left: 4px;
}
.fs-overview {
  font-size: 0.875rem;
}
</style>
